import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: string | number): string {
  // Remove any non-digit characters
  const numericValue = String(value).replace(/\D/g, '');
  
  if (!numericValue || numericValue === '0') {
    return '';
  }
  
  // Convert to number and format with commas
  const number = parseInt(numericValue, 10);
  return `£${number.toLocaleString('en-GB')}`;
}

export function parseCurrencyInput(value: string): string {
  // Remove everything except digits
  return value.replace(/\D/g, '');
}
